import { getAwmFunds } from '@repo/accounts-services'
import { defineSagaForService, DownloadServiceConfiguration } from '@repo/core'
import { awmFundsDataActions, awmFundsDownloadActions } from '../../../../../slices'

export const serviceConfig = defineSagaForService({
  [awmFundsDataActions.getRequest.type]: {
    apiClientDomain: 'accounts',
    service: getAwmFunds,
    getError: (error) => error.response?.data || error.message,
    actionTypeResponse: awmFundsDataActions.getResponse.type,
    actionTypeRequest: awmFundsDataActions.getRequest.type,
  },
  [awmFundsDataActions.refreshRequest.type]: {
    apiClientDomain: 'accounts',
    service: getAwmFunds,
    getError: (error) => error.response?.data || error.message,
    actionTypeResponse: awmFundsDataActions.refreshResponse.type,
    actionTypeRequest: awmFundsDataActions.refreshRequest.type,
  },
})

export const fileDownloadConfig: Record<string, DownloadServiceConfiguration> = {
  [awmFundsDownloadActions.downloadRequest.type]: {
    apiClientDomain: 'accounts',
    service: getAwmFunds as DownloadServiceConfiguration['service'],
    actionTypeRequest: awmFundsDownloadActions.downloadRequest.type,
    actionTypeResponse: awmFundsDownloadActions.downloadResponse.type,
  },
}
